<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-12-22 17:21:55
 * @FilePath: \mrc-ess-base-frontend\src\views\app_version_manage\index.vue
 * @最后编辑: Betway
 * @最后修改时间: 2023-03-22 18:15:26
-->
<template>
  <!-- app版本控制 -->
  <div class="parentPage" v-if="$route.name === 'app_version_manage'">
    <mrc_ess_table :headers="headers" :hideAddBtn="!hasBtn('add-app-version-manage-entry')" pageName="app_version_add"
      :paginationOptions="params" @turnPage="getData" :isLoading="loading" :slotKey="[
        'app_type',
        'device_type', 'is_forced_update',
        'show_version_code',
        'determine_version_code',
      ]" :items="desserts">
      <template v-slot:item.app_type="{ item }">
        {{ INT(item.app_type) }}
      </template>
      <template v-slot:item.device_type="{ item }">
        {{ INT(item.device_type) }}
      </template>
      <template v-slot:item.show_version_code="{ item }">
        {{ INT(item.show_version_code) }}
      </template>
      <template v-slot:item.determine_version_code="{ item }">
        {{ INT(item.determine_version_code) }}
      </template>
      <template v-slot:item.is_forced_update="{ item }">
        <mrc_ess_viewbtn :is_used="item.is_forced_update" :label="item.is_forced"></mrc_ess_viewbtn>
      </template>

      <template v-slot:item.actions="{ item }">
        <menu-list :list="showList(item)" @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <v-icon v-btnAuth="[
              'view-app-version-manage-entry',
              'edit-app-version-manage-entry',
              'delete-app-version-manage-entry',
            ]">mdi-dots-vertical</v-icon>
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <!-- 这是当前页的子页面  嵌套路由 -->
  </div>
  <transition name="fade-transform" mode="out-in" v-else>
    <router-view></router-view>
  </transition>
</template>
<script>
import confirm from "@/components/confirm";
import { get_list, getDelete } from "@/service/api/app_version";

export default {
  components: { confirm },
  props: {},
  data() {
    return {
      systemSeniorQueryString: [],
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      toolList: [
        { name: this.$t("label_Edit") },
        { name: this.$t("label_delete") },
      ],
      loading: false,
      isLoading: false,
      params: {
        "~table~": "mrbase_sys_app_version_upgrade",
        cpage: this.$store.state.cpage,
        pagesize: this.$store.state.pageSize,
        totalcount: 0, //总条数
        totalpage: 0, //总页数
      },
      desserts: [],
    };
  },
  computed: {
    headers() {
      const headers = [
        {
          text: this.$t("label_appVersion_the_apptype"),
          align: "start",
          sortable: false,
          value: "app_type",
          width: "30%",
        },
        {
          text: this.$t("label_appVersion_the_devicetype"),
          align: "start",
          sortable: false,
          value: "device_type",
          width: "30%",
        },
        {
          text: this.$t("label_appVersion_the_shwo_versioncode"),
          align: "start",
          sortable: false,
          value: "show_version_code",
          width: "20%",
        },
        {
          text: this.$t("label_appVersion_the_determine_versioncode"),
          align: "start",
          sortable: false,
          value: "determine_version_code",
          width: "10%",
        },
        {
          text: this.$t("label_appVersion_the_forced_update"),
          align: "center",
          sortable: false,
          value: "is_forced_update",
          width: "10%",
        },
        {
          text: "",
          align: "end",
          sortable: false,
          value: "actions",
          width: "20%",
        },
      ];
      return headers;
    },
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1);
  },
  async created() {
    await this.getBtnPermissionList();
  },
  async mounted() {
    await this.getData();
  },
  methods: {
    showList(item) {
      const del = {
        name: this.$t("label_delete"),
        show: this.hasBtn("delete-app-version-manage-entry"),
      };
      const arr = [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-app-version-manage-entry"),
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-app-version-manage-entry"),
        },
      ];
      if (!item.change) {
        arr.push(del);
      }
      return arr;
    },
    // 获取list数据
    async getData(obj) {
      if (obj) {
        const { cpage, pagesize } = obj;

        this.params = { ...this.params, ...obj };
      }
      this.loading = true;
      const data = await get_list({
        cpage: this.params.cpage,
        pagesize: this.params.pagesize,
        "~table~": "mrbase_sys_app_version_upgrade",
      });
      this.desserts = data.data;
      this.params.totalpage = data.totalpage;
      this.params.totalcount = data.totalcount;
      this.loading = false;
    },
    handleClick({ index }, item) {
      if (index == 0) {
        this.$store.commit("set_subPage_name", item.app_type);
        this.$store.commit("set_uuid", item.uuid);
        this.$store.commit("set_change", item.is_change);
        this.$store.commit("set_iconstatus", true);
        this.$router.push({
          name: "app_version_detail",
          params: {
            name: item.app_type,
            uuid: item.uuid,
            is_change: item.is_change,
          },
        });
      }
      // 编辑
      if (index == 1) {
        this.edit_version(item.app_type, item.uuid, item.change);
      }
      if (index == 2) {
        this.del_version(item.uuid);
      }
    },
    // 编辑版本
    edit_version(name, uuid, is_change) {
      this.$store.commit("set_subPage_name", name);
      this.$store.commit("set_uuid", uuid);
      this.$store.commit("set_change", is_change);
      this.$store.commit("set_iconstatus", false);
      this.$router.push({
        name: "app_version_detail",
        params: {
          name,
          uuid,
          is_change,
        },
      });
    },
    // 删除版本
    del_version(id) {
      this.$myConfirm({ content: this.$t("message_Confirm_the_deletion") })
        .then(async () => {
          this.isLoading = true;
          const obj = Object.assign(
            {},
            { uuid: id, "~table~": "mrbase_sys_app_version_upgrade" }
          );
          const del = await getDelete(obj);
          if (del.code == 200) {
            this.$Message({
              text: this.$t("message_The_deletion_was_successful"),
            });
          }
          this.isLoading = false;
          // this.desserts.length === 1  只有一条数据 删除就请求上一页的数据
          if (this.desserts.length === 1 && this.params.cpage > 1) {
            this.params.cpage--;
            this.totalpage--;
          }
          await this.getData();
        })
        .catch(() => { });
    },
  },
};
</script>